<template>
  <v-container v-if="articles">
      <v-row
        no-gutters
      >
        <v-col>
        </v-col>
        <v-col>
        </v-col>
        <v-col>
        </v-col>
        <v-col>
          <v-btn type="button" color="primary" @click="redirect('')" class="mr-4">Crear Articulo</v-btn>
        </v-col>
      </v-row>
    </v-container>
  <v-table density="compact">
    <thead>
      <tr>
        <th class="text-center">
          Titulo
        </th>
        <th class="text-center">
          Fecha
        </th>
        <th class="text-center">
          Editar
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="item in articles"
        :key="item.id"
      >
        <td class="text-left">{{ item.title }}</td>
        <td class="text-left">{{ item.publication_date }}</td>
        <td class="text-left">
          <v-btn type="button" color="primary" @click="redirect(item.id)" class="mr-4">
            Editar
          </v-btn>
        </td>
      </tr>
    </tbody>
  </v-table>
</template>

<script>
  import gql from "graphql-tag";

  export default {
    apollo: {
      articles: {query: gql` {
         articles:myArticles{
          id
          resumen
          title
          publication_date:publicationDateFormated
        }
      }`
    },
  },
    name:"ArticlesChess",
    data () {
      return {
        articles:null,
        search:"",
      }
    },
    methods:{
      redirect(id){
        if(id){
          window.location.href = '/crear_articulo/' + id
        } else {
          window.location.href = '/crear_articulo'
        }

      }
    }
  }
</script>

